export const FETCH_ORDER_DETAIL_PENDING = 'FETCH_ORDER_DETAIL_PENDING';
export const FETCH_ORDER_DETAIL_REJECTED = 'FETCH_ORDER_DETAIL_REJECTED';
export const FETCH_ORDER_DETAIL_FULFILLED = 'FETCH_ORDER_DETAIL_FULFILLED';
export const CLEAR_FETCH_ORDER_DETAIL = 'CLEAR_FETCH_ORDER_DETAIL';



// WEBPACK FOOTER //
// ./src/constants/changeItemOrderDetail.js